import type { StringKey } from '../data/i18n';
import type { FunnelData } from '../types/funnel';
import { digitsOnly } from './format';

export type StepErrors = Partial<Record<string, StringKey>>;

const emailOk = (s: string) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(s.trim());

export function stepErrors(step: number, d: FunnelData): StepErrors {
  const e: StepErrors = {};
  if (step === 0) {
    if (!d.homeType) e.homeType = 'errRequired';
    if (!d.bedrooms) e.bedrooms = 'errRequired';
  }
  if (step === 1) {
    if (!/^\d{5}$/.test(d.originZip)) e.originZip = 'errZip';
    if (!/^\d{5}$/.test(d.destZip)) e.destZip = 'errZip';
    for (const s of d.stops ?? []) if (!/^\d{5}$/.test(s.zip)) e[`stop_${s.id}`] = 'errZip';
  }
  if (step === 0 && d.homeType === 'office') {
    delete e.bedrooms;
    if (!d.officeSize) e.officeSize = 'errRequired';
  }
  if (step === 3) {
    const any = Object.values(d.inventory).some((q) => q > 0) || d.customItems.length > 0;
    if (!any && !d.inventoryUnsure) e.inventory = 'errInventory';
  }
  if (step === 4 && !d.packing) e.packing = 'errRequired';
  if (step === 5) {
    if (!d.moveDate && !d.dateUnsure) e.moveDate = 'errDate';
    if (!d.arrival) e.arrival = 'errArrival';
    if (d.arrival === 'other' && !d.arrivalOther.trim()) e.arrivalOther = 'errRequired';
  }
  if (step === 6) {
    if (!d.firstName.trim()) e.firstName = 'errRequired';
    if (!d.lastName.trim()) e.lastName = 'errRequired';
    if (digitsOnly(d.phone).length !== 10) e.phone = 'errPhone';
    if (!emailOk(d.email)) e.email = 'errEmail';
    if (!d.consentQuote) e.consentQuote = 'errConsent';
  }
  if (step === 8 && d.thirdPartyPayer) {
    if (!d.payerName.trim() || !emailOk(d.payerEmail)) e.payer = 'errPayer';
  }
  return e;
}
